<div style="height: 160px" class="banner">
  <ng-container *ngIf="isDesktop">
    <img src="../../../../public/assets/images/medical-consultation-background.png" alt="" />
  </ng-container>
  <div class="texts" nz-col [nzSpan]="12" nzXs="24" nzSm="24" nzLg="24" nzXl="12" nzMd="24">
    <p class="title"><img *ngIf="isDesktop" src="../../../../public/assets/images/MedicineBox.png" alt="" />{{ 'medicalConsultations.title' | translate }}</p>
    <p class="subtitle">{{ 'medicalConsultations.subTitle' | translate }}</p>
  </div>
</div>
<div nz-row [nzGutter]="[32, 32]">
  @if (appointments && appointments[0] && (appointments[0].appointmentStartDate || appointments[0].consultDate)) {
    <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="8">
      <app-card-next-appointment class="appointments-card" [appointments]="appointments" (getAppointments)="getAppointments()"></app-card-next-appointment>
    </div>
  }
  <div class="calendar" nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="8">
    <div class="calendar-container" style="background-color: white">
      <div style="font-size: 16px; font-weight: bold; padding-top: 10px; padding-left: 10px; padding-bottom: 6px">{{ 'medicalConsultations.calendar' | translate }}</div>
      <nz-calendar [nzFullscreen]="false" [nzDateCell]="dateCell"></nz-calendar>
      <ng-template #dateCell let-date>
        <div [ngClass]="{ highlight: isHighlighted(date) }">
          {{ date.getDate() }}
        </div>
      </ng-template>
      <!-- <nz-calendar [nzFullscreen]="false" (nzSelectChange)="onValueChange($event)" (nzPanelChange)="onPanelChange($event)"></nz-calendar> -->
    </div>
  </div>
  <div nz-col nzXs="24" nzSm="24" nzMd="24" nzLg="24" nzXl="8">
    <nz-card class="reminder-card">
      <div class="card-header">
        <span>{{ 'medicalConsultations.reminder' | translate }} {{ appointments?.[0]?.date }}</span>
      </div>
      <div class="task-list">
        <div *ngFor="let task of tasks" class="task-item" [class.completed]="task.completed">
          <span style="font-size: 14px">{{ task.text }}</span>
          @if (task.completed) {
            <ng-container>
              <i nz-icon nzType="check-circle" nzTheme="outline" class="task-check-icon"></i>
            </ng-container>
          } @else {
            <ng-template>
              <a *ngIf="task.actionText">{{ task.actionText }}</a>
            </ng-template>
          }
        </div>
      </div>
    </nz-card>
  </div>

  @if (healthBookingsText) {
    <nz-col [nzSpan]="24">
      <app-card-list [healthBookings]="healthBookingsText"></app-card-list>
    </nz-col>
  }

  @if (this.carouselElements && this.carouselElements.cardsContent && this.carouselElements.cardsContent.length > 0) {
    <app-carousel-card [carouselElements]="carouselElements" (carouselEmitter)="onCarouselCarePathwayEmit($event)"></app-carousel-card>
  }

  @if (appointmentsText) {
    <nz-col [nzSpan]="24">
      <app-appointments-table [isFrom]="'home-page'" [columns]="columns" [appointmentText]="appointmentsText" [appointments]="appointments.slice(0, 5)"></app-appointments-table>
    </nz-col>
  }
  @if (pastAppointmentsText) {
    <nz-col [nzSpan]="24">
      <app-appointments-table
        [isFrom]="'home-page'"
        [columns]="columns"
        [appointmentText]="pastAppointmentsText"
        [appointments]="pastAppointments.slice(0, 5)"
      ></app-appointments-table>
    </nz-col>
  }
  <nz-col [nzSpan]="24" class="container-button">
    <ds-button
      class="button-medical-appointment"
      [text]="'medicalConsultations.appointmentsHistory' | translate"
      [width]="'medium'"
      [styleType]="'empty-main'"
      [iconRight]="'/public/assets/images/icon-right-blue.svg'"
      [routerLink]="['appointments-history']"
    ></ds-button>
  </nz-col>
</div>
